import React from 'react';
import styles from './ProjectCardSummary.module.scss';
import { WidgetItem } from './WidgetItem/WidgetItem';
import { ProjectProgress } from '../../../../../../../../Models/ProjectValue';
import { formatDate } from '../../../../../../../../Helpers';
import { CustomerContext } from 'ui-smartforce-settings';

export interface ProjectCardSummaryProps {
  startDate: string;
  endDate: string;
  progress: ProjectProgress;
  allDay: boolean;
}

export const ProjectCardSummary = ({
  startDate,
  endDate,
  progress,
  allDay
}: ProjectCardSummaryProps): React.ReactElement<ProjectCardSummaryProps> => {
  const timezone = React.useContext(CustomerContext).customer
    ?.timezone as string;

  return (
    <div className={styles.projectCardSummary}>
      <WidgetItem
        title="Start Date"
        value={formatDate(
          startDate,
          `MM/DD/YYYY${allDay ? '' : ' - HH:mm'}`,
          timezone
        )}
      />
      <WidgetItem
        title="End Date"
        value={formatDate(
          endDate,
          `MM/DD/YYYY${allDay ? '' : ' - HH:mm'}`,
          timezone
        )}
      />
      <WidgetItem
        title="Progress"
        value={`${progress.current} of ${progress.total} days`}
      />
      <WidgetItem title="Repeat" value="Never" isLastItem={true} />
    </div>
  );
};
